"use strict";
class IdleTimeout {
    constructor(element, options) {
        this._options = {
            delay: 1000 * 60 * 10,
            pollDelay: 1000 * 60,
            keepAliveEvents: ['keydown', 'mousedown', 'mousemove', 'touchstart', 'touchend', 'wheel']
        };
        this._done = true;
        this._resetPoll = () => {
            clearTimeout(this._timer);
            const timeLeft = this.delay - this.duration;
            const pollDelay = this.pollDelay > timeLeft ? timeLeft : this.pollDelay;
            this._timer = window.setTimeout(this._pollHandler, pollDelay);
        };
        this._pollHandler = () => {
            this._dispatchEvent('idletimeout-poll');
            if (this.duration < this.delay) {
                this._resetPoll();
                return;
            }
            this._dispatchEvent('idletimeout-expire');
            this.cancel();
        };
        this._eventHandler = (event) => {
            if (this._done) {
                return;
            }
            if (event.type === 'message' && event.data !== 'idletimeout-reset') {
                return;
            }
            this.resetTimer();
        };
        this._element = element;
        this._options = Object.assign({}, this._options, options);
        this.resetTimer();
    }
    _initEventListeners() {
        this._options.keepAliveEvents.forEach((eventName) => {
            this._element.addEventListener(eventName, this._eventHandler);
        });
        window.addEventListener('message', this._eventHandler);
    }
    _destroyEventListeners() {
        this._options.keepAliveEvents.forEach((eventName) => {
            this._element.removeEventListener(eventName, this._eventHandler);
        });
        window.removeEventListener('message', this._eventHandler);
    }
    _dispatchEvent(eventName) {
        const event = new CustomEvent(eventName, { bubbles: true, cancelable: true, detail: this });
        this._element.dispatchEvent(event);
    }
    resetTimer() {
        if (this._done) {
            this._done = false;
            this._initEventListeners();
        }
        this._dispatchEvent('idletimeout-start');
        this._startTime = Date.now();
        this._resetPoll();
    }
    cancel() {
        this._done = true;
        clearTimeout(this._timer);
        this._destroyEventListeners();
    }
    get element() {
        return this._element;
    }
    get duration() {
        return Date.now() - this._startTime;
    }
    get delay() {
        return this._options.delay;
    }
    get pollDelay() {
        return this._options.pollDelay;
    }
    get startTime() {
        return this._startTime;
    }
}


